import { wikiURL } from '@/config/urls'
import { ifNotListener } from '../before'

export const commonPages = [
  {
    path: '/error',
    name: 'ErrorRoute',
    meta: {
      isDisplayInSidebar: false,
      group: 'Ошибка 404',
      displayName: 'Страница не найдена',
    },
    component: () =>
      import(
        /* webpackChunkName: "ErrorRoute" */ '@/views/common/ErrorRoute.vue'
      ),
  },
  {
    path: '/enroll',
    name: 'EnrollRoute',
    meta: {
      isDisplayInSidebar: false,
      displayName: 'Регистрация',
    },
    beforeEnter: ifNotListener,
    component: () =>
      import(
        /* webpackChunkName: "ErrorRoute" */ '@/views/common/EnrollRoute.vue'
      ),
  },
  {
    path: '/help',
    name: 'HelpRoute',
    meta: {
      icon: ['fas', 'question-circle'],
      isDisplayInSidebar: true,
      group: 'Главное',
      displayName: 'Справка',
    },
    beforeEnter: () => {
      window.location.href = wikiURL
    },
  },
]
